import { baseUrl, serverBaseUrl } from '@/utils/global'
import axios from '../axios'
import { IFileUploadData } from './file.types'
import urlJoin from 'url-join'
/**
 * 文件上传 
 */
export function fileUpload(file: File) {
    const f = new FormData()
    f.append('file', file)
    return axios<IFileUploadData>({
        method: 'post',
        url: '/file/upload',
        data: f,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

/**
 * 原始文件上传
 */
export function fileUploadRaw(file: File) {
    const f = new FormData()
    f.append('file', file)
    return axios<IFileUploadData>({
        method: 'post',
        url: '/file/fullUpload',
        data: f,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

/**
 * 文件全路径
 */
export function buildFullFileUrl(path: string) {
    if (!path) {
        return path
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
    }
    path = path.replaceAll('\\', '/')
    return urlJoin(serverBaseUrl, path)
}
